export default {
  directives: {
    // 使用v-focus时对话框必须用v-if设置显示隐藏
    'focus': {
      inserted: function(el) {
        el.focus()
      }
    },
    'fo': {
      inserted(el, binding, vnode) {
        el.querySelector('input').focus()
      }
    }
  }
}
